import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'users',
    serviceName: 'unitadmin',
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            categories {
              id
              title
              lab {
                title
              }
              unit {
                title
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteUserCategoryItem',
    serviceName: 'unitadmin',
    query: gql`
      mutation deleteUserCategoryItem($user_ids: [String], $category_ids: [String]) {
        deleteUserCategoryItem(user_ids: $user_ids, category_ids: $category_ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
